import { Component, OnInit, ViewChild, Renderer2, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PtImageMappingService } from '../../../service/pt-image-mapping.service';
import { SpecimenPreviewService } from '../../../service/specimen-preview.service';
import { ObervableService } from '../../../service/obervable.service';
import { AppConfigService } from 'app-config';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { CaseAddImageDailogComponent } from './../dailog/case/case-add-image-dailog/case-add-image-dailog.component';
import { CaseCopyImageDailogComponent } from './../dailog/case/case-copy-image-dailog/case-copy-image-dailog.component';
import { CaseRemoveImageDailogComponent } from './../dailog/case/case-remove-image-dailog/case-remove-image-dailog.component';
import { CaseLogImageComponent } from './../dailog/case/case-log-image/case-log-image.component';
import { SearchByAnatomicFields, SearchByCaseFields } from './case-base.classes';
import { ConstantService } from './../../../service/constant.service';
import { ExcelExportService } from './../../../service/excel-export.service';

@Component({
	selector: 'app-case-based',
	templateUrl: './case-based.component.html',
	styleUrls: ['./case-based.component.scss']
})
export class CaseBasedComponent implements OnInit {

	@ViewChild(MatPaginator) paginator: MatPaginator;
	public displayedColumns: string[] = ['diagnosis', 'diagnosisCode', 'testResultForm', 'sequance_no', 'externalImageName', 'imageSourceName', 'imageType', 'imageSubType', 'image_no', 'action'];
	public dataSource = new MatTableDataSource([]);
	public isDataSourceBlack: boolean = false;
	public pageSizeOptions = [];
	public pageSize;
	public showTotalPages = 10;

	@ViewChild('lightbox') lightbox;
	public lightBoxImagePath: any;

	public capOrgURL = AppConfigService.settings.apiServer.capOrg;
	public staffURL = AppConfigService.settings.apiServer.staffHome;

	public anatomicSiteCode: string;
	public resetAnatomicSiteCode: string;
	public caseNumberID: number;
	public caseRowsData: Array<object> = [];
	public anatomicSiteList: Array<object> = [];
	public primaryDiagnosisList: Array<object> = [];
	public diagnosisCodeList: Array<object> = [];
	public slideTypeList: Array<object> = [];
	public caseSlideTypeList: Array<object> = [];
	public searchByAnatomicForm: SearchByAnatomicFields = new SearchByAnatomicFields();
	public searchByCaseForm: SearchByCaseFields = new SearchByCaseFields();
	public alertSuccessMessage: string = null;
	public isCommitteeMember: boolean;
	public isCAPStaff: boolean;
	public isCopyImage: boolean;
	public isExportExcel: boolean;
	public isQualityControl: boolean = true;
	private isAdvSearchByAnatmicSite:boolean = false;
	private isAdvSearchByCaseNumber:boolean = false;
	private isAdvSearchByImageName:boolean = false;
	public isValidImageSourceName: boolean = false;

	private obervableService: ObervableService;
	private specimenPreviewService: SpecimenPreviewService;
	private constantService: ConstantService;
	private ptImageMappingService: PtImageMappingService;
	private excelExportService: ExcelExportService;
	public program: string = '';

	constructor(
		public dialog: MatDialog,
		private activatedRoute: ActivatedRoute,
		private injector: Injector,
		private renderer: Renderer2) {

		this.obervableService = injector.get<ObervableService>(ObervableService);
		this.specimenPreviewService = injector.get<SpecimenPreviewService>(SpecimenPreviewService);
		this.constantService = injector.get<ConstantService>(ConstantService);
		this.ptImageMappingService = injector.get<PtImageMappingService>(PtImageMappingService);
		this.excelExportService = injector.get<ExcelExportService>(ExcelExportService);

		// ACTIVE ROUTE TO GET THE PARAMS( ANATOMIC SITE CODE, CASE #)
		this.activatedRoute.params.subscribe(param => {
			if (param.anatomicSiteCode) {
				this.anatomicSiteCode = param.anatomicSiteCode;
				this.resetAnatomicSiteCode = param.anatomicSiteCode;
				this.searchByAnatomicForm.anatomicCode = this.anatomicSiteCode;
				this.searchByAnatomicForm.testResultForm = "Y";

				// POPULATE THE TABLE AND SEARCH DRPODOWN BASED ON THE AMATOMIC SITE.
				this.getMappedImageFunction(param.anatomicSiteCode, true);
				this.populatePrimaryDiagnosis(param.anatomicSiteCode);
			}

			// POPULATE THE TABLE BASED ON THE CASE #.
			if (param.caseNumber) {
				this.caseNumberID = param.caseNumber;
				this.searchByAnatomicForm.anatomicCode = "";
				this.searchByCaseForm.case = param.caseNumber;
				this.getMappedImagesByCaseNumber(param.caseNumber);
			}
		});
	}

	ngOnInit(): void {
		// TO GET THE PERMISSION
		this.isCAPStaff = this.constantService.getCAPStaffPermision();
		this.isCommitteeMember = this.constantService.getCommitteeMemberPermision();
		this.isQualityControl = (this.isCAPStaff) ? false : true;

		// TO GET THE ANATOMIC SIDE AND POPULATE THE ANATOMIC DROP-DOWN
		this.getAnatomicSite();
		// TO GET THE SLIDE TYPE AND POPULATE THE SLIDE TYPE DROP-DOWN.
		this.getSlideType();
	}

	// TO GET THE TABLE DATA BASED ON THE ANATOMIC SITE AND CALLING TO POPULATE FUNCTION
	getMappedImageFunction = (anatomicSiteCode, isAnatomic: boolean = false) => {
		this.ptImageMappingService.caseImageMapping(anatomicSiteCode).subscribe((result: Array<object>) => {
			this.prepareDataTable(result, isAnatomic);
		});
	}

	// TO GET THE CASE NUMBER AND CALLING TO POPULATE FUNCTION
	getMappedImagesByCaseNumber = (caseNumber) => {

		this.isCopyImage = true;
		this.ptImageMappingService.getCaseStatus(caseNumber).subscribe((result: Array<any>) => {
			if (result?.length > 0) {
				const caseStatus = result[0];
				this.searchByCaseForm.reason = caseStatus.description;
				this.searchByCaseForm.status = caseStatus.code;
				this.program = caseStatus.program;
				this.isQualityControl = (caseStatus.code != 'Quality Control' && this.isCommitteeMember) ? true : false;
			}else {
				this.searchByCaseForm.reason = '';
				this.searchByCaseForm.status = '';
				this.program = '';
				this.isQualityControl = false;
			}

			this.ptImageMappingService.getCaseImageName(caseNumber).subscribe((caseRow: Array<object>) => {
				this.prepareDataTable(caseRow);
				const imageName = caseRow.filter((item: any) => item.name !== null);
				this.isCopyImage = (imageName.length > 0) ? true : false;
			});
		});
	}

	// TO GET ANATOMIC SITE LIST AND POPULATE THE SEARCH DROPDOWN
	getAnatomicSite = () => {
		this.ptImageMappingService.getAnatomicSite().subscribe(result => {
			this.anatomicSiteList = result;
		});
	}

	// TO GET THE SLIDE TYPE AND POPULATE THE SEARCH DROPDOWN.
	getSlideType = () => {
		this.ptImageMappingService.getSlideTypeData().subscribe(result => {
			this.slideTypeList = result;
		});
	}

	// CHANGE ANATOMIC DROPDOWN EVENT TO RESET VALUE AND POPULATE THE DIAGNOSIS.
	onChangeAnatomic = (event) => {
		this.primaryDiagnosisList = [];
		this.caseSlideTypeList = [];

		this.searchByAnatomicForm.diagnosis = "";
		this.searchByAnatomicForm.diagnosisCode = "";
		this.searchByAnatomicForm.testResultForm = "";
		this.searchByAnatomicForm.slideType = "";
		this.searchByAnatomicForm.case = "";

		if (event.target.value !== '') {
			this.anatomicSiteCode = event.target.value;
			this.populatePrimaryDiagnosis(event.target.value);
		}
	}

	// TO CHANGE DIAGNOSIS AND POPULATE THE CASE DROPDOWN
	onChangeDaigonis = (event) => {
		this.searchByAnatomicForm.diagnosisCode = event.target.value;
		this.searchByAnatomicForm.diagnosis = event.target.value;
		if (event.target.value !== '') {
			this.ptImageMappingService.populateCaseDropDown(event.target.value).subscribe(result => {
				this.caseSlideTypeList = result;
			});
		} else {
			this.caseSlideTypeList = [];
			this.searchByAnatomicForm.case = '';
		}
	}

	// TO CHANGE THE SLIDE TYPE AND POPULATE THE CASE SLIDE TYPE LIST DROPDOWN
	onChangeSubType = (event) => {
		if (event.target.value !== '') {
			this.ptImageMappingService.getSlideTypeCaseList(this.anatomicSiteCode, event.target.value).subscribe((result: Array<object>) => {
				this.caseSlideTypeList = result;
			});
		} else {
			this.ptImageMappingService.populateCaseDropDown(this.searchByAnatomicForm.diagnosisCode).subscribe(result => {
				this.caseSlideTypeList = result;
			});
		}
	}

	onChangeCase = (event) => {
		this.searchByAnatomicForm.case = event.target.value;
	}

	// SEARCH BY ANATOMIC SITE TO CALL AND GET THE TABLE DATA AND POPULATE.
	onClickSearchAnatomicSite = () => {

		this.isAdvSearchByAnatmicSite = true;
		this.isAdvSearchByCaseNumber = false;
		this.isAdvSearchByImageName = false;

		this.caseNumberID = null;
		this.searchByCaseForm.case = '';
		this.searchByCaseForm.reason = '';
		this.searchByCaseForm.status = '';
		this.program = '';
		this.searchByCaseForm.imageName = '';
		this.searchByCaseForm.caseError = false;
		this.searchByCaseForm.imageName = '';
		this.isQualityControl = (this.isCAPStaff) ? false : true;
		this.searchByAnatomicForm.case != '' ? this.getMappedImagesByCaseNumber(this.searchByAnatomicForm.case) :
		this.getMappedImageFunction(this.anatomicSiteCode, true);
	}

	// SEARCH BY CASE # TO CALL AND GET THE TABLE DATA AND POPULATE.
	onClickSearchCase = () => {

		this.isAdvSearchByAnatmicSite = false;
		this.isAdvSearchByCaseNumber = true;
		this.isAdvSearchByImageName = false;

		this.anatomicSiteCode = '';

		this.searchByAnatomicForm.anatomicCode = "";
		this.searchByAnatomicForm.diagnosis = "";
		this.searchByAnatomicForm.diagnosisCode = "";
		this.primaryDiagnosisList = [];
		this.searchByAnatomicForm.testResultForm = "";
		this.searchByAnatomicForm.slideType = "";
		this.searchByAnatomicForm.case = "";
		this.caseSlideTypeList = [];
		this.searchByCaseForm.imageName = '';

		this.caseNumberID = Number(this.searchByCaseForm.case);
		this.isCopyImage = true;
		this.isExportExcel = false;

		this.ptImageMappingService.caseMailMappingImage(this.searchByCaseForm.case).subscribe((result: any) => {
			if (result) {
				this.searchByCaseForm.caseError = false;
				this.getMappedImagesByCaseNumber(this.searchByCaseForm.case);
			} else {
				this.searchByCaseForm.caseError = true;
			}
		});
	}

	// SEARCHING THE RESULT BASED ON THE IMAGE NAME
	onClickSearchImage = () => {

		this.isAdvSearchByAnatmicSite = false;
		this.isAdvSearchByCaseNumber = false;
		this.isAdvSearchByImageName = true;

		// RESET ANATOMIC SITE FORM
		this.searchByAnatomicForm.anatomicCode = "";
		this.searchByAnatomicForm.diagnosis = "";
		this.searchByAnatomicForm.diagnosisCode = "";
		this.primaryDiagnosisList = [];
		this.searchByAnatomicForm.testResultForm = "";
		this.searchByAnatomicForm.slideType = "";
		this.searchByAnatomicForm.case = "";
		this.caseSlideTypeList = [];

		// RESET CASE FORM
		this.searchByCaseForm.case = '';
		this.searchByCaseForm.reason = '';
		this.searchByCaseForm.status = '';
		this.program = '';
		this.searchByCaseForm.caseError = false;
		this.isQualityControl = (this.isCAPStaff) ? false : true;
		this.isCopyImage = false;
		this.isExportExcel = false;
		// GET DATA BASED ON SEARCH IMAGE NAME - SERVER CALL

		this.isValidImageSourceName = false;

		this.searchByImageName();
	}

	private searchByImageName = () => {
		this.ptImageMappingService.getSearchByImageName(this.searchByCaseForm.imageName).subscribe((result: Array<object>) => {

			if(result.length <= 0){
				this.isValidImageSourceName = true;
			}

			// MODIFIED RESULT BASED ON RESULT KEYS : BEGIN
			const modifiedResult = [];
			const uniqueResult = [];

			// CREATE AN ARRAY BASED ON RESULT KEYS FOR CHECK DUPLICATES ROWS.
			result.forEach((item: any) => {
				modifiedResult.push({
					diagnosisMenu: item.diagnosisMenu,
					sequence: item.sequence,
					externalName: item.externalName,
					name: item.name,
					typeDesc: item.typeDesc,
					subTypeDesc: item.subTypeDesc,
					imageNumber: item.imageNumber
				});
			});

			// TO CHECK DUPLICATE ROWS AND PUSH ITEM IN UNIQUE ROW ARRAY.
			modifiedResult.forEach((thing, index) => {
				const _thing = JSON.stringify(thing);
				const resIndex = modifiedResult.findIndex(obj => {
					return JSON.stringify(obj) === _thing;
				});
				if (index === resIndex) {
					uniqueResult.push(result[index]);
					return resIndex;
				}
			});
			// MODIFIED RESULT BASED ON RESULT KEYS :END

			this.prepareDataTable(uniqueResult); // PREPARE DATATABLE
		});
	}

	// ON RESET CLICK - RESET ANATOMIC SEARCH FORM.
	onClickResetAnatomicSite = () => {
		this.isAdvSearchByAnatmicSite = false;
		this.isAdvSearchByCaseNumber = false;
		this.isAdvSearchByImageName = false;

		this.searchByAnatomicForm.anatomicCode = (this.caseNumberID) ? "" : this.resetAnatomicSiteCode;
		this.searchByAnatomicForm.diagnosis = "";
		this.searchByAnatomicForm.diagnosisCode = "";
		this.primaryDiagnosisList = [];
		this.searchByAnatomicForm.testResultForm = "";
		this.searchByAnatomicForm.slideType = "";
		this.searchByAnatomicForm.case = "";
		this.caseSlideTypeList = [];

		this.isCopyImage = false;
		this.isExportExcel = false;
		if (this.resetAnatomicSiteCode) {
			this.populatePrimaryDiagnosis(this.resetAnatomicSiteCode);
			this.getMappedImageFunction(this.resetAnatomicSiteCode);
		}
	}

	// ON KEY UP-EVENT TO RESET CASE REASON AND STATUS
	onKeyUpEvent = event => {
		if (event.target.value == '') {
			this.searchByCaseForm.status = "";
			this.program = '';
			this.searchByCaseForm.reason = "";
			this.searchByCaseForm.caseError = false;
		}
		this.searchByCaseForm.case = (event.target.value.length <= 7) ? event.target.value : event.target.value.substring(0, 7);
	}

	// TO GET THE PRIMARY DIAGNOSIS
	populatePrimaryDiagnosis = siteCode => {
		this.ptImageMappingService.populatePrimaryDiagnosis(siteCode).subscribe((result: Array<object>) => {
			this.primaryDiagnosisList = result;
		});
	}

	// POPULATE THE TABLE - THIS IS THE COMMON FUNCTION TO USE FOR POPULATING TABLE.
	prepareDataTable = (rows, isAnatomic: boolean = false) => {
		this.isDataSourceBlack = false;

		if (rows.length <= 0) {
			this.isDataSourceBlack = true;
		}

		this.dataSource = new MatTableDataSource(rows);
		this.dataSource.paginator = this.paginator;
		this.paginator.pageIndex = 0;
		this.dataSource.paginator._intl.itemsPerPageLabel = '';

		if (window.matchMedia('(max-width: 769px)').matches) {
			const allLength: number = this.dataSource.data.length;
			this.pageSizeOptions = [1, 2, 3, 4, 5, 6, allLength];
			this.pageSize = 1;
			this.showTotalPages = 1;
			this.paginator._changePageSize(1)
		} else {
			this.pageSizeOptions = this.constantService.getDesktopPageSizeOption(this.dataSource.data.length);
			this.pageSize = 10;
			this.showTotalPages = 10;
			this.paginator._changePageSize(10)
		}

		this.obervableService.paginationBehavior(true);

		if (isAnatomic) {
			this.populateAnatomicFilterData();
		}
	}

	// CLICK ON SEARCH BY ANATOMIC - TO FILTER THE DATA AND POPULATE.
	populateAnatomicFilterData = () => {
		if (this.searchByAnatomicForm.case !== '') {
			const caseSearch = this.dataSource.data.filter((item: any) => item.caseNumber == this.searchByAnatomicForm.case);
			this.prepareDataTable(caseSearch);
		} else {
			this.splitSearchByAnatoicForm();
		}

		this.checkSearchAnatomicFormDiagnosisCode();
	}

	splitSearchByAnatoicForm = () => {
		if (this.searchByAnatomicForm.diagnosis !== '' && this.searchByAnatomicForm.diagnosisCode !== '') {
			if (this.searchByAnatomicForm.testResultForm == '') {
				const diagnosis = this.dataSource.data.filter((item: any) => item.actionDiagnosis == this.searchByAnatomicForm.diagnosisCode);
				this.prepareDataTable(diagnosis);
			} else {
				const diagnosis = this.dataSource.data.filter((item: any) => item.actionDiagnosis == this.searchByAnatomicForm.diagnosisCode);
				const testResult = diagnosis.filter((item: any) => item.diagnosisMenu == this.searchByAnatomicForm.testResultForm);
				this.prepareDataTable(testResult);
			}
		} else if (this.searchByAnatomicForm.diagnosisCode == '' && this.searchByAnatomicForm.testResultForm !== '') {
			const testResult = this.dataSource.data.filter((item: any) => item.diagnosisMenu == this.searchByAnatomicForm.testResultForm);
			this.prepareDataTable(testResult);
		}
	}

	checkSearchAnatomicFormDiagnosisCode = () => {
		if (this.searchByAnatomicForm.diagnosisCode !== '') {
			const imageName = this.dataSource.data.filter(item => item.name !== null);
			this.isCopyImage = (imageName.length > 0) ? true : false;
			this.isExportExcel = (this.dataSource.data.length > 0) ? true : false;
		} else {
			this.isCopyImage = false;
			this.isExportExcel = false;
		}
	}

	// ON CLICK OPEN - ADD IMAGE POPUP
	onClickAdd = row => {
		row.anatomicSiteCode = this.anatomicSiteCode;
		row.caseNumberID = this.caseNumberID;
		row.is_edit = false;
		const dailogRef = this.dialog.open(CaseAddImageDailogComponent, { data: row });
		dailogRef.beforeClosed().subscribe(addData => {
			if (addData) {
				let code = (row.caseNumber != '' && row.caseNumber != '0') ? row.caseNumber : row.siteCode;
				if (this.anatomicSiteCode !== '' && this.anatomicSiteCode !== undefined) {
					const des: any = this.anatomicSiteList.find((item: any) => item.code === row.siteCode);
					code = (des) ? `${code} ${des.description}` : code;
				}
				const msg = `<b>${addData.imageName}</b> has been successfully mapped to <b>${code}</b>`;
				this.setSuccessMessage(msg);
				this.splitReturnOnClickAdd();
			}
		});
	}

	// SPLIT CODE DUE TO SONARQUB
	splitReturnOnClickAdd = () => {
		if(this.isAdvSearchByAnatmicSite === true){
			this.getMappedImageFunction(this.anatomicSiteCode, true);
		}else if (this.isAdvSearchByImageName === true){
			this.searchByImageName();
		}else{
			if (this.anatomicSiteCode) {
				this.getMappedImageFunction(this.anatomicSiteCode);
			}

			if (this.caseNumberID) {
				this.getMappedImagesByCaseNumber(this.caseNumberID);
			}
		}
	}

	// ON CLICK OPEN - UPDATE IMAGE POPUP
	onClickEdit = row => {
		row.anatomicSiteCode = this.anatomicSiteCode;
		row.caseNumberID = this.caseNumberID;
		row.is_edit = true;

		const dailogRef = this.dialog.open(CaseAddImageDailogComponent, { data: row });
		dailogRef.beforeClosed().subscribe(editData => {
			if (editData && editData.status) {
				const msg = `Edit have been successfully saved for <b>${row.name}</b>`;
				this.setSuccessMessage(msg);
				if(this.isAdvSearchByAnatmicSite === true){
					this.getMappedImageFunction(this.anatomicSiteCode, true);
				}else if (this.isAdvSearchByImageName === true){
					this.searchByImageName();
				}else{
					if (this.anatomicSiteCode) {
						this.getMappedImageFunction(this.anatomicSiteCode);
					}

					if (this.caseNumberID) {
						this.getMappedImagesByCaseNumber(this.caseNumberID);
					}
				}
			}
		});
	}

	// ON CLICK OPEN - LOG/HISTORY IMAGE POPUP
	onClickHistory = row => {
		row.anatomicSiteCode = this.anatomicSiteCode;
		row.caseNumberID = this.caseNumberID;
		this.dialog.open(CaseLogImageComponent, { data: row });
	}

	// ON CLICK OPEN - DELETE POPUP
	onClickDelete = row => {
		if (row.name) {
			row.anatomicSiteCode = this.anatomicSiteCode;
			row.caseNumberID = this.caseNumberID;
			const dailogRef = this.dialog.open(CaseRemoveImageDailogComponent, { data: row });
			dailogRef.afterClosed().subscribe(deleteData => {
				this.splitDeleteCloseResponse(deleteData, row);
			});
		}
	}

	splitDeleteCloseResponse = (deleteData, row) => {
		if (deleteData.isDelete) {
			let code = (row.caseNumber != '' && row.caseNumber != '0') ? row.caseNumber : row.siteCode;
			if (this.anatomicSiteCode !== '' && this.anatomicSiteCode !== undefined) {
				const des: any = this.anatomicSiteList.find((item: any) => item.code === row.siteCode);
				code = (des) ? `${code} ${des.description}` : code;
			}
			const msg = `<b>${row.name}</b> has been successfully removed from <b>${code}</b>`;
			this.setSuccessMessage(msg);
			this.splitDeleteCaseImage(row);
		}
	}

	splitDeleteCaseImage = row => {
		this.ptImageMappingService.deleteCaseData(row).subscribe(result => {

			if(this.isAdvSearchByAnatmicSite === true){
				this.getMappedImageFunction(this.anatomicSiteCode, true);
			}else if (this.isAdvSearchByImageName === true){
				this.searchByImageName();
			}else{
				if (this.anatomicSiteCode) {
					this.getMappedImageFunction(this.anatomicSiteCode);
				}

				if (this.caseNumberID) {
					this.getMappedImagesByCaseNumber(this.caseNumberID);
				}
			}

		});
	}

	// ON CLICK OPEN - COPY IMAGE POPUP
	onClickCopyImage = () => {
		let anatomicSiteDesc = '';

		if (this.anatomicSiteCode) {
			const anatomicSite: any = this.anatomicSiteList.find((item: any) => item.code == this.anatomicSiteCode);
			anatomicSiteDesc = anatomicSite.description;
		}

		const diagnosis: any = this.primaryDiagnosisList.find((item: any) => item.primaryDiagnosisCode == this.searchByAnatomicForm.diagnosisCode);
		const data = {
			anatomicSiteCode: this.anatomicSiteCode,
			anatomicSiteDesc: anatomicSiteDesc,
			caseNumberID: this.caseNumberID,
			diagnosisCode: (this.isCopyImage) ? this.searchByAnatomicForm.diagnosisCode : null,
			diagnosisDesc: (diagnosis) ? diagnosis.description : null
		};
		const dailogRef = this.dialog.open(CaseCopyImageDailogComponent, { data: data });
		dailogRef.afterClosed().subscribe(result => {
			if (result && result.success) {
				const msg = `${result.noOfImage} have been copied successfully to ${result.code}`;
				this.setSuccessMessage(msg);
			}
		});
	}

	// ON IMAGE CLICK OPEN - LIGHT BOX TO SHOW THE FULL IMAGE.
	openImageLightBox = (image_name, image_no) => {
		const ext = image_name.split('.').pop();
		const URL = 'PTImages/NGC/' + image_no + '.' + ext;
		this.specimenPreviewService.getImageS3Url(URL).subscribe(res => {
			if (ext == 'zip') {
				window.open(res, '_blank');
			} else if (ext == 'htm' || ext == 'html') {
				window.open(res, '_blank', 'location=yes,height=450,width=600,scrollbars=yes,status=yes');
			} else {
				this.lightBoxImagePath = res;
				this.renderer.addClass(this.lightbox.nativeElement, 'open');
				this.renderer.addClass(document.body, 'lightbox-open');
			}
		});
	}

	// LIGHT BOX CLOSE EVENT.
	closeImageLightbox() {
		this.renderer.removeClass(this.lightbox.nativeElement, 'open');
		this.renderer.removeClass(document.body, 'lightbox-open');
	}

	// TO SHOW - SUCCESS MESSAGE ON TOP. - COMMON FUNCTION
	setSuccessMessage = msg => {
		this.alertSuccessMessage = `<i class="fa fa-check-circle"></i> ${msg}`;
	}

	// ON CLICK - CREATE A CSV FILE AND DOWNLOAD IT.
	exprotExcel = () => {
		const excelTableData: any = {
			sheet1: [],
			sheet2: [],
		};

		this.ptImageMappingService.exportCaseList(this.anatomicSiteCode, this.searchByAnatomicForm.diagnosisCode).subscribe(result => {
			if (result.length > 0) {
				result.forEach(item => {
					excelTableData.sheet2.push({
						"Anatomic Site Description": item.anatomicSiteDescription,
						"Diagnosis (Primary)": item.primaryDiagnosisDescription,
						"Diagnosis (Primary) Code": item.primaryDiagnosisCode,
						"Case Number": item.caseNumber,
						"Availability Status": item.availabilityStatus,
						"Availability Reason": item.availabilityReason
					})
				});
			} else {
				excelTableData.sheet2.push({
					"Anatomic Site Description": '',
					"Diagnosis (Primary)": '',
					"Diagnosis (Primary) Code": '',
					"Case Number": '',
					"Availability Status": '',
					"Availability Reason": ''
				})
			}
			this.dataSource.data.forEach(item => {
				excelTableData.sheet1.push({
					'Diagnosis': item.diagnosis,
					'Diagnosis code': item.actionDiagnosis,
					'Test Result Form': (item.diagnosisMenu === 'Y') ? 'Yes' : 'No',
					'Sequence #': item.sequence,
					'External Image Name': item.externalName,
					'Image Source Name': item.name,
					'Image Type': item.typeDesc,
					'Image Sub-Type': item.subTypeDesc,
					'Image #': item.imageNumber
				})
			});
			this.excelExportService.exportAsExcelFile(excelTableData, 'sample');
		});
	}
}